export const WHATSAPP_NUMBER_DISPLAY = "+33 6 50 26 71 60";
export const WHATSAPP_NUMBER_INTL = "33650267160";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER_INTL}?text=${encodeURIComponent(message)}`;
